var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDevelopersIconPurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17636_52854)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.2998 9.97165V3.7C7.2998 2.98392 7.58427 2.29716 8.09062 1.79081C8.59696 1.28446 9.28372 1 9.9998 1C10.7159 1 11.4026 1.28446 11.909 1.79081C12.4153 2.29716 12.6998 2.98392 12.6998 3.7V4.6027M12.6998 10.0013V16.3C12.6998 17.0161 12.4153 17.7028 11.909 18.2092C11.4026 18.7155 10.7159 19 9.9998 19C9.28372 19 8.59696 18.7155 8.09062 18.2092C7.58427 17.7028 7.2998 17.0161 7.2998 16.3V15.3865",
    stroke: "#572148",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 12.7H3.6928C2.206 12.7 1 11.4913 1 10C1 8.50875 2.206 7.30005 3.6928 7.30005H4.59505M10 7.30005H16.295C17.0118 7.29945 17.6994 7.58357 18.2066 8.0899C18.7139 8.59624 18.9993 9.28333 19 10C19 11.4913 17.789 12.7 16.295 12.7H15.4297",
    stroke: "#572148",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17636_52854"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevelopersIconPurple);
export default __webpack_public_path__ + "static/media/developers-icon_purple.43da565752e63d0b608a6174748f9cf0.svg";
export { ForwardRef as ReactComponent };